import * as React from 'react';
import { connect } from 'react-redux';
import { limpiarFiltros } from '../../../../actions/generalActios';
import { fetchSellersFilter } from '../../../../actions/sellersActions';
import Select from 'react-select';
import { customStyleFilter } from '../../../../template/CustomStyle';
import { DropDownArrow } from "../../../../template/CustomStyle";

class FiltroDashboard extends React.Component {
  constructor(props) {
    super(props);
    const today = new Date();
    this.state = {
      fechaDesde: this.props.filtro?.fechaDesde || today.toISOString().split('T')[0],
      verMes: this.props.filtro?.verMes !== undefined ? this.props.filtro?.verMes : false,
      mes: today.getMonth() + 1, // 1-12
      anio: today.getFullYear(),
      seller: { label: "Todos", value: "" },
    }
  }

  componentDidMount() {
    this.checkAndFetchSellers();

    // If no filter exists in Redux or fechaDesde is empty, trigger the default search (Month to Date)
    if (!this.props.filtro || !this.props.filtro.fechaDesde) {
      this.triggerDefaultFilter();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userType !== this.props.userType || prevProps.tipoUsuario != this.props.tipoUsuario) {
      this.checkAndFetchSellers();
    }
  }

  checkAndFetchSellers = () => {
    // Intentamos cargar los sellers si es admin/category (1 o 2). 
    // Usamos PascalCase para los parámetros por si acaso (match listSellersParameters).
    // Forzamos la carga incluso si ya hay sellers, para asegurar que tenemos la paginación correcta (5).
    if (this.props.tipoUsuario == 1 || this.props.tipoUsuario == 2) {
      this.props.fetchSellersFilter({
        Descripcion: "",
        Page: 1,
        PageSize: 100
      });
    }
  }

  triggerDefaultFilter = () => {
    const { fechaDesde, verMes, mes, anio, seller } = this.state;
    // Calculate dates for "Ver Mes" logic
    let finalDesde = fechaDesde;
    let finalHasta = fechaDesde;

    if (verMes) {
      const parts = fechaDesde.split('-');
      if (parts.length === 3) {
        finalDesde = `${parts[0]}-${parts[1]}-01`;
        finalHasta = fechaDesde;
      }
    }

    const filtro = {
      fechaDesde: finalDesde,
      fechaHasta: finalHasta,
      verMes,
      idSeller: seller ? seller.value : null,
      mes,
      anio,
      sellerObj: seller
    };

    this.props.chargeFilterOptions(filtro);
  }

  onSelectSearchInputSellers = (descripcion, action) => {
    // Solo buscar cuando el usuario escribe, no cuando selecciona
    if (action.action === 'input-change') {
      this.props.fetchSellersFilter({ 
        Descripcion: descripcion,
        Page: 1,
        PageSize: 100
      });
    }
  }

  selectSearchHandler = (option) => {
    this.setState({ seller: option });
  }

  handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState({
      [name]: type === 'checkbox' ? checked : value
    });
  }

  onFilter = (e) => {
    e.preventDefault();
    const { fechaDesde, verMes, mes, anio, seller } = this.state;
    const { tipoUsuario } = this.props;


    let idSeller = null;
    if (tipoUsuario == 1 || tipoUsuario == 2) {
      idSeller = seller ? seller.value : null;
    }

    // Calcular fechas inicio/fin si es 'verMes'
    let finalDesde = fechaDesde;
    let finalHasta = fechaDesde; // O null, según lógica dashboard

    if (verMes) {
      // Si Ver Mes está activo:
      // Desde: 1° del mes de la fecha seleccionada
      // Hasta: La fecha seleccionada

      if (!fechaDesde) {
        // Fallback porsiacaso, aunque debería tener valor o validarse
        const today = new Date();
        finalHasta = today.toISOString().split('T')[0];
        finalDesde = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0];
      } else {
        // Forma segura string: YYYY-MM
        const parts = fechaDesde.split('-'); // [2026, 01, 15]
        if (parts.length === 3) {
          finalDesde = `${parts[0]}-${parts[1]}-01`;
          finalHasta = fechaDesde;
        }
      }

    } else {
      // Si Ver Mes está APAGADO:
      // Desde: Fecha seleccionada
      // Hasta: Fecha seleccionada
      finalDesde = fechaDesde;
      finalHasta = fechaDesde;
    }

    const filtro = {
      fechaDesde: finalDesde,
      fechaHasta: finalHasta,
      verMes,
      idSeller, // El dashboard lo necesita
      // Info Extra para re-hidratar el estado si volvemos
      mes,
      anio,
      sellerObj: seller
    };

    this.props.chargeFilterOptions(filtro);
  }

  onClearFilter = () => {
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];

    this.setState({
      fechaDesde: formattedDate,
      verMes: false,
      mes: today.getMonth() + 1,
      anio: today.getFullYear(),
      seller: { label: "Todos", value: "" }
    }, () => {
      this.props.limpiarFiltros({ dashboard: true });
      this.triggerDefaultFilter();
    });
  }

  render() {
    // Construir lista de opciones segura (sin mutar props)
    const sellersOptions = (this.props.sellers || []).map(item => ({
      label: item.label,
      value: item.value.toString()
    }));

    // Agregar "Todos" al principio
    sellersOptions.unshift({ value: "", label: "Todos" });

    return (
      <div
        className="card card-body filter-card mb-3 dashboard-filtro-card"
        style={{
          background: 'linear-gradient(to right, #fff0f0, #ffffff)',
          border: 'none',
          boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
        }}
      >
        <div className="dashboard-filtro-scroll">
          <form
            className="form-material dashboard-filter-bar d-flex flex-nowrap align-items-center gap-2 gap-md-3"
            onSubmit={this.onFilter}
            onReset={this.onClearFilter}
          >
            <div className="form-check form-switch custom-switch ps-0 mb-0 flex-shrink-0">
              <input
                type="checkbox"
                id="checkVerMes"
                name="verMes"
                className="form-check-input ms-0 me-2"
                style={{ cursor: 'pointer', width: '2.5rem', height: '1.25rem' }}
                onChange={this.handleChange}
                checked={this.state.verMes}
              />
              <label
                className="form-check-label label-oscura mb-0 text-nowrap"
                htmlFor="checkVerMes"
                style={{ cursor: 'pointer', fontWeight: 500, fontSize: '0.9rem', paddingTop: '2px' }}
              >
                Ver por Mes
              </label>
            </div>

            <div className="d-flex align-items-center gap-2 flex-shrink-0 dashboard-filtro-fecha">
              <label htmlFor="fechaDashboardFiltro" className="label-oscura mb-0 text-nowrap">
                Fecha
              </label>
              <input
                id="fechaDashboardFiltro"
                type="date"
                name="fechaDesde"
                className="form-control dashboard-filtro-date-input"
                onChange={this.handleChange}
                value={this.state.fechaDesde}
                title={
                  this.state.verMes
                    ? 'Acumulado desde el 1° del mes hasta la fecha seleccionada'
                    : 'Indicadores correspondientes solo a la fecha seleccionada'
                }
              />
              <span className="dashboard-filter-hint-inline text-muted" role="note">
                {this.state.verMes ? 'Mes acumulado' : 'Solo día'}
              </span>
            </div>

            {(this.props.tipoUsuario == 1 || this.props.tipoUsuario == 2) && (
              <div className="d-flex align-items-center gap-2 flex-grow-1 dashboard-filtro-seller">
                <span className="label-oscura mb-0 text-nowrap">Seller</span>
                <div className="dashboard-filtro-seller-select">
                  <Select
                    inputId="dashboardSellerSelect"
                    name="seller"
                    value={this.state.seller}
                    options={sellersOptions}
                    onChange={this.selectSearchHandler}
                    onInputChange={this.onSelectSearchInputSellers}
                    components={{ DropdownIndicator: () => DropDownArrow }}
                    styles={{
                      ...customStyleFilter,
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({
                        ...customStyleFilter.menu(base),
                        zIndex: 9999,
                      }),
                    }}
                    menuPortalTarget={document.body}
                    placeholder="Buscar Seller..."
                  />
                </div>
              </div>
            )}

            <div className="d-flex flex-shrink-0 gap-2 ms-auto dashboard-filtro-actions">
              <button type="submit" className="btn btn-sm background-rojo-megatone text-white px-3 shadow-sm" disabled={this.props.isLoading}>
                <i className="mdi mdi-magnify mr-1"></i> Buscar
              </button>
              <button type="reset" className="btn btn-sm btn-outline-secondary px-3 shadow-sm">
                Limpiar
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}


const mapStateToProps = state => ({
  isLoading: state.dashboard.isLoading,
  idSeller: state.general.idSeller,
  userType: state.general.userType,
  tipoUsuario: state.general.tipoUsuario,
  sellers: state.sellers.filteredSellers,
});

export default connect(mapStateToProps, {
  limpiarFiltros,
  fetchSellersFilter // Mantener si otras partes lo usan, pero aca ya no es critico para el dropdown
})(FiltroDashboard)